import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARWriteOffActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/WriteOff/WriteOffBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARWriteOff"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARWriteOff"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARWriteOffActivity)
